import { UserPermissions } from '@centecomm/portal-service';
import { FeatureConfiguration } from 'Core/Types/FeatureConfiguration';
import AdministrationNavigationIcon from 'Icons/NavigationItem/Administration';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements';

const LazyCompanySettingsPage = React.lazy(() => import('./Pages'));

const companySettingsConfiguration: FeatureConfiguration = {
    name: 'administrationFeature:company.settings.title',
    navigationItem: {
        route: {
            text: 'administrationFeature:sidebar.company.settings.title',
            url: '/company-config-settings',
            Icon: AdministrationNavigationIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyCompanySettingsPage />
                </React.Suspense>
            ),
            tenantRoot: null,
            childItems: [],
        },
        isGloballyAccessible: false,
        permissions: [UserPermissions.ManageAdminConfig],
    },
    disableFeature: [],
};

export default companySettingsConfiguration;
